class URLResolver {
  private searchParams = new URLSearchParams(window.location.search);

  private _parseUrlSearchParams = (name: string): string | null => (
    this.searchParams.get(name)
  );

  public getValue = <ResultType = string>(name: string): ResultType =>
    (this._parseUrlSearchParams(name) || '') as unknown as ResultType;

  public getArrayValue = <ResultType = string[]>(name: string): ResultType =>
    (this._parseUrlSearchParams(name)?.split(',') || []) as unknown as ResultType;
}

export default URLResolver;
